// RespiteCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import FlexibleRespiteCareSection from '../components/FlexibleRespiteCareSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import HowRespiteCareWorksSection from '../components/HowRespiteCareWorksSection';
import RespiteSupportSection from '../components/RespiteSupportSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const RespiteCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Respite Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Here For You When You Need Relief and Rest"
        description="Let a caring respite worker from B & N Enterprise step in while you take a well-earned break."
      />
      <FlexibleRespiteCareSection />
      <ProudlyCaringSeniorsSection />
      <HowRespiteCareWorksSection />
      <RespiteSupportSection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default RespiteCare;
